import { withInstall } from '@antdv/utils';
import AToolTip from './src/Tooltip';

export const Tooltip = withInstall(AToolTip);

export default Tooltip;

export * from './src/interface';
export * from './src/props';
